import { render, staticRenderFns } from "./tableRegion.vue?vue&type=template&id=3c0b2aaa&scoped=true"
import script from "./tableRegion.vue?vue&type=script&lang=js"
export * from "./tableRegion.vue?vue&type=script&lang=js"
import style0 from "./tableRegion.vue?vue&type=style&index=0&id=3c0b2aaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0b2aaa",
  null
  
)

export default component.exports